<!-- 360 IMAGE -->
<div
  #container
  class="viewer"
  [ngClass]="{ 'viewer--thumbnail': isThumbnail }"
></div>
